import api from "./Api";

class FaturamentoItemService {
  GetFaturamentoItemOData(payload) {
    return api.get("/OData/FaturamentoItem" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new FaturamentoItemService();
